import { render, staticRenderFns } from "./ApplyInvestMoney.vue?vue&type=template&id=56c5b938&scoped=true&"
import script from "./ApplyInvestMoney.vue?vue&type=script&lang=js&"
export * from "./ApplyInvestMoney.vue?vue&type=script&lang=js&"
import style0 from "./ApplyInvestMoney.vue?vue&type=style&index=0&id=56c5b938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c5b938",
  null
  
)

export default component.exports